import { render, staticRenderFns } from "./ReleasesTimeline.vue?vue&type=template&id=a07dab92&scoped=true"
import script from "./ReleasesTimeline.vue?vue&type=script&lang=js"
export * from "./ReleasesTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07dab92",
  null
  
)

export default component.exports